module.exports = __webpack_public_path__ + "static/media/projectsImage12.6a6d5520.jpg";